<ng-container *ngIf="filteredItems$ | async as abteilungen">
  <div class="flex flex-row w-full py-2 z-100 bg-surface-secondary border-b">
    <soft-filter-and-sort
      class="w-full px-4"
      [explorer]="explorerAbteilungen"
      [filterConfig]="filterConfig"
      [sortConfig]="sortConfig"
    >
    </soft-filter-and-sort>
  </div>

  @if (abteilungen.length > 0 || (loading$ | async) === false) {
    <div class="flex flex-col gap-2 select-none overflow-y-auto p-4">
      @for (abteilung of explorerAbteilungen.result(); track abteilung.id) {
        <soft-abteilung-card
          [abteilung]="abteilung"
          [routerLink]="['./abteilung', abteilung?.abteilung?.id]"
          [queryParamsHandling]="'preserve'"
        >
        </soft-abteilung-card>
      } @empty {
        <div
          class="text-sm italic text-center w-full flex items-center justify-center p-6"
        >
          Keine Abteilungen gefunden
        </div>
      }
    </div>
  } @else {
    <ng-container *ngTemplateOutlet="skeleton"></ng-container>
  }

  <ng-template #skeleton>
    <div class="flex flex-col mt-5 pb-5 gap-2 px-4">
      <div class="flex soft-card rounded w-full h-20" *softRepeat="5">
        <div class="flex flex-col gap-2.5 items-start pb-1.5 pt-2">
          <div class="h-4 w-20 skeleton rounded"></div>
          <div class="h-4 w-36 skeleton rounded"></div>
        </div>
      </div>
    </div>
  </ng-template>
</ng-container>
